<script lang="ts">
export default {
  name: "CGU",
  setup() {
    function back() {
      return history.back();
    }
    return {
      back,
    };
  },
};
</script>

<template>
  <div class="cgu">
    <h1 class="title">
      {{ $t("footer.cgu.title") }}
    </h1>
    <div class="justify">
      <p class="paragraphe">
        {{ $t("footer.cgu.intro") }}
      </p>
    </div>
    <h2>{{ $t("footer.cgu.definition.title") }}</h2>
    <div class="justify">
      <p class="paragraphe">
        {{ $t("footer.cgu.definition.message") }}
      </p>
    </div>
    <div class="justify">
      <ul class="fa-ul">
        <li>
          <span class="fa-li"><b-icon
            class="fas"
            icon="user-shield"
            type="is-primary"
          /></span><span
            class="paragraphe"
            v-html="$t('footer.cgu.definition.admin')"
          />
        </li>
        <li>
          <span class="fa-li"><b-icon
            class="fas"
            icon="circle-notch"
            type="is-primary"
          /></span><span
            class="paragraphe"
            v-html="$t('footer.cgu.definition.reuse')"
          />
        </li>
        <li>
          <span class="fa-li"><b-icon
            class="fas"
            icon="user"
            type="is-primary"
          /></span><span
            class="paragraphe"
            v-html="$t('footer.cgu.definition.user')"
          />
        </li>
      </ul>
    </div>
    <h2>{{ $t("footer.cgu.access-title") }}</h2>
    <div class="justify">
      <span
        class="paragraphe"
        v-html="$t('footer.cgu.access-definition')"
      />
    </div>
    <h2>{{ $t("footer.cgu.cookies.title") }}</h2>
    <div class="justify">
      <span
        class="paragraphe"
        v-html="$t('footer.cgu.cookies.info')"
      />
    </div>
    <h2>{{ $t("footer.cgu.responsibilities-users.title") }}</h2>
    <div class="justify">
      <span
        class="paragraphe"
        v-html="$t('footer.cgu.responsibilities-users.info')"
      />
    </div>
    <h2>{{ $t("footer.cgu.personal-data.title") }}</h2>
    <div class="justify">
      <span
        class="paragraphe"
        v-html="$t('footer.cgu.personal-data.info')"
      />
    </div>
    <h2>{{ $t("footer.cgu.commitments-responsibilities.title") }}</h2>
    <div class="justify">
      <span
        class="paragraphe"
        v-html="$t('footer.cgu.commitments-responsibilities.info')"
      />
    </div>
    <h2>{{ $t("footer.cgu.changes-condition-use.title") }}</h2>
    <div class="justify">
      <span
        class="paragraphe"
        v-html="$t('footer.cgu.changes-condition-use.info')"
      />
    </div>
    <h2>{{ $t("footer.cgu.users-personal-data.title") }}</h2>
    <div class="justify">
      <span
        class="paragraphe"
        v-html="$t('footer.cgu.users-personal-data.info')"
      />
    </div>
    <h2>{{ $t("footer.cgu.reference-texts.title") }}</h2>
    <div class="justify">
      <span
        class="paragraphe"
        v-html="$t('footer.cgu.reference-texts.info')"
      />
    </div>
    <b-button
      type="is-primary"
      @click="back"
    >
      {{ $t("footer.return") }}
    </b-button>
  </div>
</template>

<style lang="scss" scoped>
.cgu {
  margin: 5em 8em 5em 8em;
  padding-bottom: 8em;
}

.title {
  font-size: 3em;
}

h2 {
  font-size: 2em;
}

h3 {
  font-size: 1.5em;
  font-weight: 600;
  color: $primary;
}

.fas {
  margin-top: 1.25em;
  margin-right: 1em;
}
.justify {
  text-align: justify;
  .paragraphe {
    font-size: 1.4em;
  }
}
</style>
